<template>
  <div>
  </div>
</template>
<script>

export default {
  name: 'broomeExtra',
  props: ['value'],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
